import React from "react";
import { useSelector } from "react-redux";
import { useGetTasksQuery } from "../../features/tasks/tasksApi";
import AddNewBtn from "./AddNewBtn";
import Task from "./Task";

const TaskList = () => {
  const { data: tasks } = useGetTasksQuery();
  const { checked, search } = useSelector((state) => state.filter);

  const filterByProject = (item) => {
    return checked.includes(item.project.projectName);
  };

  const filterBySearch = (item) => {
    return item.taskName.toLowerCase().includes(search.toLowerCase());
  };

  const filteredTasks = tasks?.filter(filterByProject)?.filter(filterBySearch);

  return (
    <div className="lg:pl-[16rem] 2xl:pl-[23rem]">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <AddNewBtn />

        <div className="lws-task-list">
          {filteredTasks?.map((task) => (
            <Task key={task.id} task={task} />
          ))}
        </div>
      </main>
    </div>
  );
};

export default TaskList;
